import React from "react";
import Dashboard from "./Dashboard";

const PrequalDashboard = ({ dashboardId, sessionToken }) => {
  return <Dashboard dashboardId={dashboardId} sessionToken={sessionToken} title="Prequal Dashboard" />;
};

export default PrequalDashboard;
